import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import "antd/dist/antd.css";
import { DatePicker } from 'antd';
import Swal from 'sweetalert2';
import moment from 'moment';
import axios from 'axios';
import { baseURL } from '../backend_url';
import { formatDate, formatDate_withTime } from '../commonFunctions';
import { MDBDataTable } from 'mdbreact';
// import { ExportReactCSV } from './ExportReactCSV';
import { Alert } from "@mui/material";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";


export default function OneWayRental({ company_id }) {

  const [columnData, setColumnData] = useState([])
  const [rowData, setRowData] = useState([])


  //This is for scrolling
  const titleRef = useRef()

  function handleBackClick() {
    titleRef.current.scrollIntoView({ behavior: 'smooth' })
  }


  useEffect(() => {

    axios.get(baseURL + "/get_audit/" + (company_id + "||one_way_rental"))
      .then((res) => {

        let column_data = []

        column_data.push(
          {
            label: 'Account ID',
            field: 'company_id',
            sort: 'asc',
            width: 270
          },
          {
            label: 'From (Location ID)',
            field: 'location_id_from',
            sort: 'asc',
            width: 100
          },
          {
            label: 'From (Location Name)',
            field: 'location_name_from',
            sort: 'asc',
            width: 100
          },
          {
            label: 'To (Location ID)',
            field: 'location_id_to',
            sort: 'asc',
            width: 100
          },
          {
            label: 'To (Location Name)',
            field: 'location_name_to',
            sort: 'asc',
            width: 100
          },
          {
            label: 'Car Class',
            field: 'car_class',
            sort: 'asc',
            width: 150
          },
          {
            label: 'Drop Fees',
            field: 'drop_fees',
            sort: 'asc',
            width: 270
          },
          {
            label: 'Currency',
            field: 'currency',
            sort: 'asc',
            width: 400
          },
          {
            label: 'From (Date)',
            field: 'from_date',
            sort: 'asc',
            width: 100
          },
          {
            label: 'To (Date)',
            field: 'to_date',
            sort: 'asc',
            width: 100
          },
          {
            label: 'Open Ended?',
            field: 'open_ended',
            sort: 'asc',
            width: 100
          },
          {
            label: 'Created By',
            field: 'created_by',
            sort: 'asc',
            width: 100
          },
          {
            label: 'Updated By',
            field: 'updated_by',
            sort: 'asc',
            width: 100
          },
          {
            label: 'Created On',
            field: 'created_date',
            sort: 'asc',
            width: 100
          },
          {
            label: 'Updated On',
            field: 'updated_date',
            sort: 'asc',
            width: 100
          },
          {
            label: 'IP Address',
            field: 'ip_address',
            sort: 'asc',
            width: 100
          },
          {
            label: 'Deleted?',
            field: 'deleted?',
            sort: 'asc',
            width: 100
          }

        )


        setColumnData(column_data);

        let rows_data = [];

        const myDataSet = res.data;
        for (var index = 0; index < res.data.length; index++) {


          let rowItem = {};
          const val = myDataSet[index];
          rowItem["company_id"] = val.company_id
          rowItem["location_id_from"] = val.location_id_from
          rowItem["location_id_to"] = val.location_id_to
          rowItem["location_name_from"] = val.location_name_from
          rowItem["location_name_to"] = val.location_name_to
          rowItem["car_class"] = val.car_class
          rowItem["drop_fees"] = val.drop_fees
          rowItem["currency"] = val.currency
          rowItem["from_date"] = val.from_date ? formatDate(new Date(val.from_date)) : "-"
          rowItem["to_date"] = val.to_date ? formatDate(new Date(val.to_date)) : '-'
          rowItem["open_ended"] = val.open_ended ? "Yes" : "No"
          rowItem["created_by"] = val.created_by
          rowItem["updated_by"] = val.updated_by
          rowItem["created_date"] = formatDate_withTime(new Date(val.created_date))
          rowItem["updated_date"] = formatDate_withTime(new Date(val.updated_date))
          rowItem["ip_address"] = val.ip_address
          rowItem["deleted?"] = val['deleted?']

          rows_data.push(rowItem)
        }


        setRowData(rows_data)
      }).catch((e) => { });



  }, [])


  //Table Data
  const data = {
    columns: columnData,
    rows: rowData
  };




  return (
    <>

      <div className="row mt-3">
        <div className="col-md-12">
          <h5 className="mb-3">One Way Rental Audit/Event Log: </h5>
          <MDBDataTable
            bordered
            large={true}
            data={data}
            sortable={true}
            responsiveLg={true}
            noBottomColumns={true}
            className='cust-table'
            btn
            
          />


        </div>
      </div>
    </>
  );
}
